export enum EstadoAutorizacionAev {
    Libre,
    Autorizado,
    Contado,
    SinConexion,
    Preautorizado,
    Granel
}